import type { DiscountCalculator } from './DiscountCalculator';
import type { DiscountBxgy } from '@/modules/store/models/Discount';
import type { Amount, CalculatedPrice, Price } from '@/modules/store/models/Price';
import { roundPayableAmount, roundUnitPrice } from '@/utils/currency/roundPrice';

export class BxgyDiscountCalculator implements DiscountCalculator<DiscountBxgy> {
  isApplicable(quantity: number, discount: DiscountBxgy): boolean {
    const setSize = discount.buyQuantity + discount.getQuantity;
    return quantity >= setSize;
  }

  calculate(originalPrice: Price, quantity: number, discount: DiscountBxgy): CalculatedPrice {
    const originalAmount = originalPrice.price;
    const unitPrice = roundUnitPrice(originalAmount.amount);
    const originalLineAmount = roundPayableAmount(quantity * unitPrice);

    if (!this.isApplicable(quantity, discount)) {
      return {
        ...originalAmount,
        amount: originalLineAmount,
        originalPrice: { ...originalAmount, amount: originalLineAmount },
        discountedPrice: { ...originalAmount, amount: originalLineAmount },
        discountBxgy: discount,
      };
    }

    const setSize = discount.buyQuantity + discount.getQuantity;
    const sets = Math.floor(quantity / setSize);
    const paidQuantity = sets * discount.buyQuantity + (quantity % setSize);

    const discountedPrice: Amount = {
      currencyCode: originalAmount.currencyCode,
      amount: roundPayableAmount(paidQuantity * unitPrice),
    };

    return {
      ...discountedPrice,
      originalPrice: { ...originalAmount, amount: originalLineAmount },
      discountedPrice,
      discountBxgy: discount,
    };
  }
}
